import React from "react";
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, Autocomplete, TextField 
} from "@mui/material";
import { commonRemarks, checklistItems } from "../constants/options";

const ChecklistSection = ({ formData, handleCheckboxChange, handleAutocompleteChange }) => {
  const items = checklistItems[0];

  return (
    <TableContainer
      component={Paper}
      sx={{
        overflowX: 'auto',
        maxWidth: '100vw',
        '& table': {
          tableLayout: 'fixed',
          width: '100%',
          minWidth: 850,
        },
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 30, whiteSpace: 'nowrap' }}>No</TableCell>
            <TableCell sx={{ width: 300, whiteSpace: 'normal' }}>Special Informations</TableCell>
            <TableCell sx={{ width: 50 }}>Yes</TableCell>
            <TableCell sx={{ width: 50 }}>No</TableCell>
            <TableCell sx={{ width: 50 }}>NA</TableCell>
            <TableCell sx={{ width: 100, whiteSpace: 'normal' }}>Remarks</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.key.map((item, index) => (
            <TableRow key={index}>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>{index + 1}</TableCell>
              <TableCell sx={{ whiteSpace: 'normal' }}>{items.name[index]}</TableCell>
              <TableCell>
                <Checkbox
                  checked={formData[item] === "Yes"}
                  onChange={() => handleCheckboxChange(item, "Yes")}
                />
              </TableCell>
              <TableCell>
                <Checkbox
                  checked={formData[item] === "No"}
                  onChange={() => handleCheckboxChange(item, "No")}
                />
              </TableCell>
              <TableCell>
                <Checkbox
                  checked={formData[item] === "NA"}
                  onChange={() => handleCheckboxChange(item, "NA")}
                />
              </TableCell>
              <TableCell sx={{ width: 400, padding: 0 }}>
                <Autocomplete
                  freeSolo
                  options={commonRemarks || []}
                  value={formData[`${item}_remarks`] || ""}
                  onChange={(event, newValue) => handleAutocompleteChange(`${item}_remarks`, newValue || "")}
                  onInputChange={(event, newInputValue) => handleAutocompleteChange(`${item}_remarks`, newInputValue)}
                  sx={{ width: '100%' }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      multiline
                      minRows={2}
                      placeholder="Remarks"
                      variant="outlined"
                      size="small"
                      sx={{ width: '100%', boxSizing: 'border-box', padding: '8px' }}
                    />
                  )}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ChecklistSection;
